export default {
    save: 'Save',
    close: 'Close',
    from: 'from',
    till: 'till',
    of: 'of',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    cancel: 'Cancel',
    'no-data': 'There is nothing found',
    'no-results': 'There is nothing found for this filter',
    'snackbar-saved': 'It\'s successfully saved!',
    'snackbar-save-error': 'Something went wrong, please try again later',
    'snackbar-get-error': 'Something went wrong, please try again later',
    'snackbar-deleted': 'It\'s successfully deleted!',
    'snackbar-delete-error': 'Something went wrong, please try again later',
    'search': 'Search',
    'loading': 'Loading..',
    'delete-confirmation-title': 'Are you sure?',
    'delete-confirmation-content': 'Are you sure you want to delete these item(s)?',
};
